/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportStores$Params {
  'Active-Tenant-Identifier': string;

/**
 * Specify the content types, expressed as MIME types, the client is able to understand. Endpoint only supports 'text/csv' at the moment
 */
  Accept: string;

/**
 * Text search parameter. Search against store name, address, city, state fields.
 */
  query?: string;
  isOrderingEnabled?: boolean;
  isChildStore?: boolean;
  isStoreHoursSet?: boolean;
  isPrepTimeSet?: boolean;
  isDefaultTaxRateSet?: boolean;
  isChannelSetup?: boolean;
  isPaymentConfigured?: boolean;
  isPosConfigured?: boolean;
  isPosOnlineAndReady?: boolean;
  hasParentHub?: boolean;
  storeStatus?: Array<'new' | 'lab' | 'active' | 'nonOrderingStore' | 'temporarilyClosed' | 'permanentlyClosed'>;
  posStatus?: Array<'online' | 'onlineAndReady' | 'offline'>;
  posSystem?: Array<string>;

/**
 * Filter entity attributes with an RSQL like syntax.
 * For now only the equality comparison operator `==` the contains operator `=in=` and the AND logic operator `;` are supported.
 * The value of this parameter must be encoded.
 * Examples: `filter=name=="Some Store Name";` should be sent encoded as: `filter=name%3D%3D%22Some%20Store%20Name%22`
 * `filter=storeStatus=in=(live, permanentlyClosed);` should be sent encoded as: `filter=storeStatus%3Din%3D(live%2C%20permanentlyClosed)`
 */
  filter?: string;

/**
 * List of attributes to export. By default, all attributes are returned.<br>
 * Example: ?attribute=id&attribute=name; this will export only id and name attributes.<br>
 * List of available attributes: id, name, storeStatus, storeNumber, storeAddress, state, posStatus, franchise, dataGroup, posSystem, posVersion, posIntegration, posHost
 */
  attribute?: Array<string>;
}

export function exportStores(http: HttpClient, rootUrl: string, params: ExportStores$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, exportStores.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.header('Accept', params.Accept, {});
    rb.query('query', params.query, {});
    rb.query('isOrderingEnabled', params.isOrderingEnabled, {});
    rb.query('isChildStore', params.isChildStore, {});
    rb.query('isStoreHoursSet', params.isStoreHoursSet, {});
    rb.query('isPrepTimeSet', params.isPrepTimeSet, {});
    rb.query('isDefaultTaxRateSet', params.isDefaultTaxRateSet, {});
    rb.query('isChannelSetup', params.isChannelSetup, {});
    rb.query('isPaymentConfigured', params.isPaymentConfigured, {});
    rb.query('isPosConfigured', params.isPosConfigured, {});
    rb.query('isPosOnlineAndReady', params.isPosOnlineAndReady, {});
    rb.query('hasParentHub', params.hasParentHub, {});
    rb.query('storeStatus', params.storeStatus, {"style":"form","explode":true});
    rb.query('posStatus', params.posStatus, {"style":"form","explode":true});
    rb.query('posSystem', params.posSystem, {"style":"form","explode":false});
    rb.query('filter', params.filter, {});
    rb.query('attribute', params.attribute, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

exportStores.PATH = '/stores/export';
